import { AxiosPromise } from 'axios';

import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';

type DashboardResponse<T = any> = {
  MENSAJE_RESPUESTA?: string;
  CODIGO_RESPUESTA?: string;
  LISTA?: T;
};

type RequestParams<T = any> = {
  serviceClient?: string;
  endpoint?: string;
  body?: { [key: string]: T };
};

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

const makeHttpRequest = ({
  serviceClient = 'api_capacitaciones',
  endpoint = 'get_categorias',
  body = {},
}: RequestParams): AxiosPromise<DashboardResponse> =>
  axios.http.post<DashboardResponse>(
    `Metabase/PostgenericA/${serviceClient}/${endpoint}`,
    body
  );

export const fetchMantenedorCapacitaciones = (
  params: RequestParams
): AxiosPromise<DashboardResponse> => makeHttpRequest(params);
